import _assign from "object-assign";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { refType } from '@material-ui/utils';
import { Button } from '@jpmuitk/button';
import { useFormFieldProps } from '@jpmuitk/form-field';
import { Icon } from '@jpmuitk/icon';
import { withStyles } from '@jpmuitk/theme';
import { style } from './style';
var DropdownButton = /*#__PURE__*/forwardRef(function DropdownButton(_ref, ref) {
  var ariaHideOptionRole = _ref.ariaHideOptionRole,
      classes = _ref.classes,
      className = _ref.className,
      _ref$density = _ref.density,
      density = _ref$density === void 0 ? 'medium' : _ref$density,
      disabled = _ref.disabled,
      iconName = _ref.iconName,
      iconSize = _ref.iconSize,
      isOpen = _ref.isOpen,
      label = _ref.label,
      labelId = _ref.labelId,
      inField = _ref.inField,
      fullWidth = _ref.fullWidth,
      labelAriaAttributes = _ref.labelAriaAttributes,
      rest = _objectWithoutProperties(_ref, ["ariaHideOptionRole", "classes", "className", "density", "disabled", "iconName", "iconSize", "isOpen", "label", "labelId", "inField", "fullWidth", "labelAriaAttributes"]);

  var _useFormFieldProps = useFormFieldProps(),
      inFormField = _useFormFieldProps.inFormField;

  var focusVisibleClassName = inFormField || inField ? classes.formField : undefined;
  return /*#__PURE__*/React.createElement(Button, _assign({
    className: classnames(classes["".concat(density, "Density")], classes.button, className, _defineProperty({}, classes.fullWidth, fullWidth)),
    classes: {
      focusVisible: focusVisibleClassName
    } // We don't want the 'button' tag to be shown in the DOM to trigger some accessability testing
    // tool's false alarm on role of 'listbox'
    ,
    component: "div",
    density: density,
    disabled: disabled,
    ref: ref,
    variant: "secondary"
  }, rest), /*#__PURE__*/React.createElement("div", {
    className: classes.content
  }, /*#__PURE__*/React.createElement("span", _assign({
    // 'hidden' so that screenreader won't be confused the additional 'option' which is just a label
    "aria-hidden": ariaHideOptionRole ? 'true' : undefined
  }, labelAriaAttributes, {
    className: classes.buttonLabel,
    id: labelId // 'option' role here is to suppress accessibility testing tool warning about 'listbox' missing children role.
    ,
    role: "option"
  }), label), /*#__PURE__*/React.createElement(Icon, {
    className: classes.icon,
    name: iconName,
    size: iconSize
  })));
});
process.env.NODE_ENV !== "production" ? DropdownButton.propTypes = {
  ariaHideOptionRole: PropTypes.bool,
  buttonRef: refType,
  className: PropTypes.string,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  density: PropTypes.oneOf(['touch', 'high', 'medium', 'low']),
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
  iconName: PropTypes.string.isRequired,
  iconSize: PropTypes.number,
  inFormField: PropTypes.bool,
  isOpen: PropTypes.bool,
  label: PropTypes.string,
  labelAriaAttributes: PropTypes.objectOf(PropTypes.string),

  /**
   * Id for the label. This is needed for ARIA attributes.
   */
  labelId: PropTypes.string,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  onKeyDown: PropTypes.func,
  onKeyUp: PropTypes.func
} : void 0; // TODO (BREAKING CHANGE REQUIRED)
// https://issuetracking.jpmchase.net/jira12/browse/JPMUITK-2835
// Add unique JPMUI prefix to name to identify component as a Toolkit component

export default withStyles(style, {
  name: 'DropdownButton'
})(DropdownButton);
//# sourceMappingURL=DropdownButton.js.map